import React from 'react';

interface NavigationMenuProps {
    toggleDropdown: (value: number) => void;
    openDropdown: number | null;
    dropdownRef: any;
    menuNumber: number;
    children?: React.ReactNode;
    headline?: string;
    icon?: React.ReactNode;
    isUserProfile?: boolean;
}

export default function NavigationMenu({
    toggleDropdown,
    openDropdown,
    dropdownRef,
    menuNumber,
    children,
    headline,
    icon,
    isUserProfile = false,
}: NavigationMenuProps) {
    return (
        <div className="relative navigationMenuButton">
            <button
                onClick={() => toggleDropdown(menuNumber)}
                className={`navigationMenuButton p-0 rounded-full h-[50px] w-[50px] flex items-center justify-center transition-all duration-200 text-navHeader-button-icon hover:text-navHeader-button-icon-hover ${
                    isUserProfile ? 'overflow-hidden' : 'bg-navHeader-button hover:bg-navHeader-button-hover'
                }
                `}
            >
                {icon}
            </button>
            {openDropdown === menuNumber && (
                <div
                    ref={dropdownRef}
                    className="absolute top-[60px] right-0 min-w-[320px] bg-config-boxBackgroundColor rounded-lg shadow-lg p-6 z-50 flex flex-col gap-6"
                >
                    <h4 className="m-0 p-0">{headline}</h4>
                    <hr className="border-t border-layout-borderColor w-full mb-0 mt-0"></hr>
                    {children}
                </div>
            )}
        </div>
    );
}
